<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <v-select
            :value="fields['card-left']"
            :items="postionOptions"
            label="Title Position"
            @change="handleChangePositionLeft"
          />
          <div class="mb-5">
            <label>Title</label>
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
            <v-row class="mt-4">
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="text-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['text-color']"
                      @change="handleChangeTextColor"
                    />
                    <v-text-field v-model="fields['text-color']" label="Text Color" />
                    <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="background-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['background-color']"
                      @change="handleChangeBackgroundColor"
                    />
                    <v-text-field v-model="fields['background-color']" label="Background Color" />
                    <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="">
            <div class="d-flex justify-space-between align-center" style="margin-bottom: 10px">
              <label style="margin-bottom: 0" class="label-input">Table Columns</label>
              <v-btn v-if="fields.columnCount < 3" small text color="primary" @click="handleAddColumn">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Column</span>
              </v-btn>
            </div>
            <div class="row-head">
              <div class="wrap-left-small"></div>
              <div class="wrap-right-small">
                <div>
                  <v-text-field v-model="fields['first-title']" label="First Title" />
                </div>
                <div>
                  <v-text-field v-model="fields['second-title']" label="Second Title" />
                </div>
                <div v-if="fields.columnCount >= 3" class="d-flex align-center">
                  <v-text-field v-model="fields['third-title']" label="Third Title" />
                </div>
                <div class="action-col">
                  <v-btn v-if="fields.columnCount >= 3" icon @click.stop="handleRemoveColumn">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label style="margin-bottom: 0" class="label-input">Table Body</label>
            </div>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="table-body">
            <div v-for="(item, index) in fields.listItem" :key="index" class="row-body">
              <div class="wrap-left-small">
                <v-text-field v-model="item.comparisonContent" label="Comparison Content" />
              </div>
              <div class="wrap-right-small">
                <div>
                  <v-checkbox v-model="item.firstTd" />
                </div>
                <div>
                  <v-checkbox v-model="item.secondTd" />
                </div>
                <div v-if="fields.columnCount >= 3">
                  <v-checkbox v-model="item.thirdTd" />
                </div>
                <div class="action-col">
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <v-row class="mt-4">
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="table-body-background"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['table-body'].background"
                  @change="handleChangeTableBodyBackground"
                />
                <v-text-field v-model="fields['table-body'].background" label="Background" />
                <v-btn @click="handleResetTableBodyBackground" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="table-body-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['table-body'].color"
                  @change="handleChangeTableBodyColor"
                />
                <v-text-field v-model="fields['table-body'].color" label="Color" />
                <v-btn @click="handleResetTableBodyColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding</label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'card-with-table-compare-section-editor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      postionOptions: [
        {
          text: 'Left',
          value: 1,
        },
        {
          text: 'Right',
          value: 2,
        },
      ],
      fields: {
        title: '',
        listItem: [],
        'table-body': {},
        'card-title': '',
        'card-left': 1,
        'card-right': 2,
        'first-title': '',
        'second-title': '',
        'third-title': '',
        columnCount: 2,
        'text-color': '#000000',
        'background-color': '#ffffff',
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.listItem.push({
        comparisonContent: '',
        firstTd: false,
        secondTd: false,
        thirdTd: false,
      });
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleAddColumn() {
      if (this.fields.columnCount >= 3) return;
      this.fields.columnCount = 3;
      this.fields.listItem.forEach(item => {
        if (item.thirdTd === undefined) {
          this.$set(item, 'thirdTd', false);
        }
      });
    },
    handleRemoveColumn() {
      if (this.fields.columnCount <= 2) return;
      this.fields.columnCount = 2;
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardWithTableCompare(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangePositionLeft(value) {
      this.fields['card-left'] = Number(value);
      if (value === 1) {
        this.fields['card-right'] = 2;
      } else {
        this.fields['card-right'] = 1;
      }
    },
    handleChangeTextColor(e) {
      this.fields['text-color'] = e.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '#000000';
    },
    handleChangeBackgroundColor(e) {
      this.fields['background-color'] = e.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '#ffffff';
    },
    handleChangeTableBodyBackground(e) {
      this.fields['table-body'].background = e.target.value;
    },
    handleChangeTableBodyColor(e) {
      this.fields['table-body'].color = e.target.value;
    },
    handleResetTableBodyBackground() {
      this.fields['table-body'].background = '#ffffff';
    },
    handleResetTableBodyColor() {
      this.fields['table-body'].color = '#000000';
    },
  },
};
</script>

<style lang="scss" scoped>
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.row-head {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  .v-text-field__details {
    display: none !important;
  }
  .wrap-left-small {
    width: calc((100% - 10px) / 3);
  }
  .wrap-right-small {
    width: calc((100% - 10px) / 3 * 2);
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    > div {
      flex: 1 1 0;
      min-width: 100px;
      &.action-col {
        flex: 0 0 50px;
        min-width: 50px;
      }
    }
  }
}
.table-body {
  border: solid 1px #c1c1c1;
  padding: 15px;
  //   padding-bottom: 0;
  padding-top: 30px;
  border-radius: 5px;
}
.row-body {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  .wrap-left-small {
    width: calc((100% - 10px) / 3);
  }
  .wrap-right-small {
    width: calc((100% - 10px) / 3 * 2);
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    > div {
      flex: 1 1 0;
      min-width: 60px;
      display: flex;
      justify-content: center;
      &.action-col {
        flex: 0 0 50px;
        min-width: 50px;
      }
    }
  }
}
</style>
